<template>
  <a
    class="btn btn-sm btn-danger"
    style="font-size: 80%; margin-bottom: 1em; display: block"
    target="_blank"
    :href="poucenieLink">
    {{ $t('message.butPoucenie') }}
  </a>
</template>

<script>
export default {
  computed: {
    poucenieLink() {
      if (this.$store.state.subjectType === 'a') {
        return 'https://pfseform.financnasprava.sk/Formulare/Poucenia/DPFOAv20-poucenie.pdf';
      }
      if (this.$store.state.subjectType === 'b') {
        return 'https://pfseform.financnasprava.sk/Formulare/Poucenia/DPFOBv20-poucenie.pdf';
      }
      return null;
    }
  }
}
</script>
